export default __webpack_public_path__ + "static/media/powerpoint.abba61a5.svg";